import React from "react";

import { ReactComponent as IconLive } from "../../../assets/images/ActiveLearning/icon_live.svg";

import styles from "./TreeCard.module.scss";

interface ITreeCardProps {
  title: string;
  text: string;
  button?: React.ReactNode;
}

export const TreeCard: React.FC<ITreeCardProps> = ({ title, text, button }) => {
  return (
    <div className={styles.treeCard}>
      <div className={styles.wrapper}>
        <p className={styles.title}>
          <IconLive />
          {title}
        </p>
        <p className={styles.text}>{text}</p>
      </div>
      {button && <div className={styles.button}>{button}</div>}
    </div>
  );
};

export default TreeCard;
